<template>

  <span class="main Index">
    <HeaderOne data-aos="fade-up" class="HeaderOne"  v-if="siteSettings.HomePageContainer1Title"  :headerOne="siteSettings.HomePageContainer1Title" />
    <IntroText data-aos="fade-up" v-if="siteSettings.HomePageContainer1Desciption"  :pageItem="siteSettings" :intro-one="siteSettings.HomePageContainer1Desciption"/>
    <Overviews class="bg-background1" v-if="(useNewsOverviewStore().getAll().length > 0) || (useEventOverviewStore().getAll().length > 0)" />
    <ContainerText data-aos="fade-up" v-if="siteSettings.HomePageContainer2Title" class="bg-background1" :headerOne="siteSettings.HomePageContainer2Title" />
    <IntroText data-aos="fade-up" v-if="siteSettings.HomePageContainer2Description" class="bg-background1" :pageItem="siteSettings" :intro-one="siteSettings.HomePageContainer2Description"/>

    </span> 
</template>
<script setup>
    // components for this view (@ is an alias to /src)
import HeaderOne from '@/components/Base/headerOne.vue'
import IntroText from '@/components/Base/introText.vue'
import Overviews from '@/components/Base/homeOverviews.vue'
import ContainerText from '@/components/Base/container2Text.vue'
const siteSettings = useSiteSettingsStore();
// export default {  

// $headerMethods.formatHeader([{
//     MetaDescription:    siteJson.HomePageMetaDescription,
//     MetaTitle:          siteJson.HomePageMetaTitle,
//     MetaKeywords:       siteJson.HomePageMetaKeyWords,
//     BrowserTitle:       siteJson.HomePageTitle
//   }
// ])

 const getHeight = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 70;
    case "sm":
      return 70;
    case "md":
      return 70;
    case "lg":
      return 70;
    case "xl":
      return 90;
    case "xxl":
      return 90;      
    default:
      return 90;
  }
});
</script>